import React from "react";
import {
    Box,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Table
} from '@material-ui/core';


export default class ComponentToPrint extends React.Component {
    render() {
        const BankCustomerSearchData = this.props.BankCustomerSearchData;
        const BankCustomerData = this.props.BankCustomerData;
        const totalAmountpdf = this.props.totalAmountpdf;
        const bankName = this.props.bankName;
        const monthnew = this.props.monthnew;
        const yearNew = this.props.yearNew;
        const branchName = this.props.branchName;
        const bankCode = this.props.bankCode;
        const branchCode = this.props.branchCode;
        return (
            <div>
                <h2><center><u>Bank Customer Details Report</u></center></h2>
                <div>&nbsp;</div>
                <h3><center>BOUGHT LEAF BALANCE PAYMENT FOR THE MONTH OF {monthnew} - {yearNew}</center></h3>
                <div>&nbsp;</div>
                <div>
                    <center>
                        <h3><center>Factory: {BankCustomerSearchData.factoryName}</center></h3>
                        <h3>Route: {BankCustomerSearchData.routeName === undefined ? 'All Route' : BankCustomerSearchData.routeName}</h3>
                        <h3>Bank: {bankName}</h3>
                        <h3>Branch: {branchName === undefined || 0 ? 'All Branches' : branchName.branchName}</h3>
                    </center>
                </div>
                <div>&nbsp;</div>
                <div>
                    <Box minWidth={1050}>
                        <TableContainer >
                            <Table aria-label="caption table" size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>Route</TableCell>
                                        <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>Bank & Bank Code</TableCell>
                                        <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>Branch & Branch Code</TableCell>
                                        <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>RegNo</TableCell>
                                        <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>Name</TableCell>
                                        <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>Account Number</TableCell>
                                        <TableCell align={'right'} style={{ border: "1px solid #ccc" }}>Amount(Rs)</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {BankCustomerData.map((data, index) => (
                                        <TableRow key={index}>
                                            <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                                {data.routeName}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                                {data.bankName} - {data.bankCode}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                                {data.branchName} - {data.branchCode}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                                {data.registrationNumber}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                                {data.name}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                                {data.accountNumber}
                                            </TableCell>
                                            <TableCell align={'right'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                                {data.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                                <TableRow style={{ border: "1px solid #ccc" }}>
                                    <TableCell align={'left'} style={{ borderBottom: "none" }}><b>Total</b></TableCell>
                                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>

                                    </TableCell>
                                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>

                                    </TableCell>
                                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>

                                    </TableCell>
                                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>

                                    </TableCell>
                                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>

                                    </TableCell>
                                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none", borderLeft: "1px solid #ccc" }}>
                                        <b> {totalAmountpdf} </b>
                                    </TableCell>
                                </TableRow>
                            </Table>
                        </TableContainer>
                    </Box>
                </div>
                <div>&nbsp;</div>
                <h3><center>***** End of List *****</center></h3>
            </div>
        );

    }

}